const initialState = {
    supplierDetails: {},
    loadingSupplier: false,
    errorsSupplier: {},
    supplierStatus: [],
    changedSupplierStatus: [],
    sectors: [],
    industries: [],
    message:"",
  };
  
  const supplierReducer = (state = initialState, action) => {
    switch (action.type) {
      case "GET_SUPPLIER_DETAILS_PENDING":
      case "ADD_SUPPLIER_PENDING":
      case "UPDATE_SUPPLIER_PENDING":
      case "DELETE_SUPPLIER_PENDING":
      case "GET_SUPPLIER_SECTORS_PENDING":
      case "GET_SUPPLIER_INDUSTRIES_PENDING":
      case "UPDATE_SUPPLIER_PENDING":
      case "REQUEST_UPDATE_SUPPLIER_PENDING":
        return { ...state, loadingSupplier: true };
  
      case "RESET_SUPPLIER_STATUS":
        return {
          ...state,
          loadingSupplier: false,
          message:"",
        };
      case "GET_SUPPLIER_DETAILS_FULFILLED":
        return {
          ...state,
          loadingSupplier: false,
          supplierDetails: action.payload,
        };
  
      case "ADD_SUPPLIER_FULFILLED":
        return {
          ...state,
          loadingSupplier: false,
          changedSupplierStatus: action.payload,
        };
  
      // case "UPDATE_SUPPLIER_FULFILLED":
      //   return {
      //     ...state,
      //     loadingSupplier: false,
      //     changedSupplierStatus: action.payload,
      //   };
  
      case "DELETE_SUPPLIER_FULFILLED":
        return {
          ...state,
          loadingSupplier: false,
          changedSupplierStatus: action.payload,
        };
      case "GET_SUPPLIER_SECTORS_FULFILLED":
        return {
          ...state,
          loadingSupplier: false,
          sectors: action.payload?.subcategory,
        };
      case "GET_SUPPLIER_INDUSTRIES_FULFILLED":
        return {
          ...state,
          loadingSupplier: false,
          industries: action.payload?.projectIndustry,
        };
      case "UPDATE_SUPPLIER_FULFILLED":
        return {
          ...state,
          loadingSupplier: false,
          // supplierDetails: action.payload?.cmYuvaSupplier,
          message: action.payload?.message,
        };
      case "REQUEST_UPDATE_SUPPLIER_FULFILLED":
        return {
          ...state,
          loadingSupplier: false,
          message: action.payload?.message,
        };
  
      case "GET_SUPPLIER_DETAILS_FAILED":
      case "ADD_SUPPLIER_FAILED":
      case "UPDATE_SUPPLIER_FAILED":
      case "DELETE_SUPPLIER_FAILED":
      case "GET_SUPPLIER_SECTORS_FAILED":
      case "GET_SUPPLIER_INDUSTRIES_FAILED":
      case "UPDATE_SUPPLIER_REJECTED":
      case "REQUEST_UPDATE_SUPPLIER_REJECTED":
        return {
          ...state,
          loadingSupplier: false,
          errorsSupplier: action.payload,
        };
  
      default:
        return state;
    }
  };
  
  export default supplierReducer;
  